import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.unshift.js";
import { defineComponent, reactive, ref, getCurrentInstance, onMounted, onBeforeUnmount, nextTick, computed, h } from "vue";
import VirtualList from 'ant-design-vue/es/vc-virtual-list';
import SvgIcon from "../components/SvgIcon.vue";
import FolderCard from "@/components/FolderCard.vue";
import { useRouter } from "vue-router";
import util from "@/util/util";
import { genFileId } from "element-plus";
import QrcodeVue from "qrcode.vue";
import html2canvas from "html2canvas";
import permission from "@/util/permission";
import { ElLoading } from "element-plus";
import cookies from "js-cookie";
import { useI18n } from "vue-i18n";
import { DownCircleOutlined } from "@ant-design/icons-vue";
import store from "@/store";

import { ElNotification, ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default defineComponent({
  name: "ActivityDetail",
  components: {
    SvgIcon,
    FolderCard,
    QrcodeVue,
    DownCircleOutlined,
    VirtualList
  },
  setup() {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用
    const {
      proxy
    } = getCurrentInstance();
    const route = useRouter();
    const QRcodeVisible = ref(false);
    const QRcodeBox = ref(null);
    const QRcodeMsg = reactive({});
    const activityId = route.currentRoute.value.params.activityId;
    const tokenData = util.getToken();
    const currentProtocol = window.location.protocol;
    const currentDomain = window.location.hostname;
    const currentPort = window.location.port;
    const progressType = ref("all");
    const progressIndex = ref(0);
    const stepsCurrent = ref(0);
    const spinLoading = ref(false);
    let currentUrl = currentProtocol + "//" + currentDomain;
    if (currentPort) {
      currentUrl += ":" + currentPort;
    }
    const jumpUrl = ref(currentUrl + "/install-info/");
    // const jumpUrl = ref("https://servicechannel.online/install-info/");
    // const jumpUrl = ref("http://192.168.60.248:8080/install-info/")
    const activity = reactive({
      activityImportMessageVisible: false,
      activityImportMessages: [],
      activityStat: {},
      activityData: [],
      organizationUserData: [],
      activityImportUploaded: {},
      stepsItems: [{
        title: "STEP 1",
        status: "wait"
      }, {
        title: "STEP 2",
        status: "wait"
      }, {
        title: "STEP 3",
        status: "wait"
      }],
      videoData: {
        activityName: '',
        activityTime: '',
        taskList: [{
          taskTime: null,
          taskStoreType: [],
          taskStoreName: [],
          supportType: null
        }],
        videoUrl: [''],
        note: ''
      },
      videoTaskInfo: [],
      deleteSubTaskId: [],
      videoTaskProgress: []
    });
    const wxCodeImage = ref(null);
    const dropdownVisible = ref(false);
    const getActivityImportUploaded = async activityId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityImportUploaded(activityId, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getOrganizationUser = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.organizationRequest.getOrganizationUser(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStat = async activityId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityStat(activityId, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivity = async activityId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivity(activityId, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202154") {
              resolve(res.result.data);
            } else {
              ElNotification({
                title: t("activityDetail.fail"),
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 6000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: res.msg,
              type: "error",
              duration: 6000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreNameSet = taskIndex => {
      const list = activity.videoData.taskList?.[taskIndex]?.taskStoreName || [];
      return new Set(list);
    };
    const removeFile = uploaded => {
      ElMessageBox.confirm(t("activityDetail.confirmDeleteFile") + uploaded.fileName, t("activityDetail.inquire"), {
        confirmButtonText: t("activityDetail.confirm"),
        cancelButtonText: t("activityDetail.cancel"),
        type: "warning"
      }).then(() => {
        let activityDeleteUploadedRO = {
          activityId: activityId,
          uploadedId: uploaded.uploadedId
        };
        deleteUploadedFileRequest(activityDeleteUploadedRO, uploaded);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t("activityDetail.cancelDelete")
        });
      });
    };
    const handleClickOutside = event => {
      // popover 内容
      const popover = document.querySelector(".upload-box-popper");
      // reference 按钮
      const refBtn = document.querySelector(".upload-file-btn");

      // 如果弹框没打开，则不用处理
      if (!uploadFilePopoverVisible.value) return;

      // 点击在 popover 内部 → 不关闭
      if (popover && popover.contains(event.target)) return;

      // 点击在按钮内部 → 不关闭
      if (refBtn && refBtn.contains(event.target)) return;

      // 点击其他任何地方 → 关闭
      uploadFilePopoverVisible.value = false;
    };
    const getHeart = async obj => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getHeart(obj, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    onMounted(async () => {
      document.addEventListener("click", handleClickOutside);
      let organizationUserList = await getOrganizationUser();
      if (organizationUserList == null) {
        return;
      }
      activity.organizationUserData.push(...organizationUserList);

      // let obj = {
      //   playTaskUploadId: 'DC:62:94:56:F0:87',
      //   uploadPlayTaskName: 'KL@NBY LCD@FA25 Pet',
      //   uploadPlayTaskUrl: ['https://wplayernew.aqual.com.cn/video/d0cb5e0f0fb649408792d26910d23937.mp3','https://wplayernew.aqual.com.cn/video/7a32a03ff86b4eed9e9d88f606860262.mp3'],
      //   vendorId: 4,
      //   playTaskUploadIdType:1,
      // }
      // let heart = await getHeart(obj)
      // console.log(heart)

      loadActivityData();

      // let fffddata = {
      //   startDate:'2024-05-29',
      //   endDate:'2025-10-31',
      // }
      // let fff = await getScreenDailyCount(fffddata,true)
      // console.log(fff)

      // let ggg = await getScreeTodayCount(true)
      // console.log(ggg)
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });
    const loadActivityData = async () => {
      if (activityId != null && activityId != "") {
        if (tokenData.type == 2) {
          let activityImportUploadedList = await getActivityImportUploaded(activityId);
          if (Array.isArray(activityImportUploadedList)) {
            for (let uploaded of activityImportUploadedList) {
              activity.activityImportUploaded[uploaded.type] = uploaded;
            }
          }
        }
        activity.activityStat = await getActivityStat(activityId);
        if (activity.activityStat != null && activity.activityStat.activityStoreTypeQuantity != null) {
          let totalQuantity = 0;
          for (let activityStoreTypeQuantity of activity.activityStat.activityStoreTypeQuantity) {
            totalQuantity += activityStoreTypeQuantity.quantity;
          }
          activity.activityStat.totalQuantity = totalQuantity;
        }
        activity.activityData = await getActivity(activityId);
        activity.activityData.activityBegin = activity.activityData.activityBegin.replaceAll("-", ".");
        activity.activityData.activityEnd = activity.activityData.activityEnd.replaceAll("-", ".");
        for (let uploaded of activity.activityData.uploaded) {
          uploaded.date = formatCurrentDate(new Date(uploaded.uploadedTime));
        }
        let managers = {};
        activity.activityManagers = [];
        if (activity.activityData.activityManagers != null) {
          for (let activityManagers of activity.activityData.activityManagers) {
            let findIndex = activity.organizationUserData.findIndex(element => element.organizationId == activityManagers.organizationId);
            if (findIndex != -1) {
              let organization = activity.organizationUserData[findIndex];
              if (managers[organization.organizationId] == null) {
                let organizationManagers = {
                  organizationId: organization.organizationId,
                  organizationName: organization.organizationName,
                  managers: [{
                    managedArea: activityManagers.managedArea,
                    lastName: activityManagers.lastName,
                    firstName: activityManagers.firstName,
                    mobile: activityManagers.mobile,
                    email: activityManagers.email
                  }]
                };
                activity.activityManagers.push(organizationManagers);
                managers[organization.organizationId] = organizationManagers;
              } else {
                managers[organization.organizationId].managers.push({
                  managedArea: activityManagers.managedArea,
                  lastName: activityManagers.lastName,
                  firstName: activityManagers.firstName,
                  mobile: activityManagers.mobile,
                  email: activityManagers.email
                });
              }
            }
          }
        }
        if (activity.activityImportUploaded[8] == null) {
          stepsCurrent.value = 0;
          activity.stepsItems = [{
            title: "STEP 1",
            status: "wait"
          }, {
            title: "STEP 2",
            status: "wait"
          }, {
            title: "STEP 3",
            status: "wait"
          }];
        } else {
          stepsCurrent.value = 1;
          activity.stepsItems = [{
            title: "STEP 1",
            status: "finish"
          }, {
            title: "STEP 2",
            status: "wait"
          }, {
            title: "STEP 3",
            status: "wait"
          }];
          if (activity.activityImportUploaded[13] != null) {
            stepsCurrent.value = 2;
            activity.stepsItems = [{
              title: "STEP 1",
              status: "finish"
            }, {
              title: "STEP 2",
              status: "finish"
            }, {
              title: "STEP 3",
              status: "wait"
            }];
            if (activity.activityImportUploaded[14] != null) {
              activity.stepsItems = [{
                title: "STEP 1",
                status: "finish"
              }, {
                title: "STEP 2",
                status: "finish"
              }, {
                title: "STEP 3",
                status: "finish"
              }];
            }
          }
        }
        if (permission.havePermission('视频发布', '查看')) {
          let storeTypeList = await getStoreType({
            activityId: activityId
          });
          if (storeTypeList == null) {
            return;
          }
          storeData.storeTypeData.push(...storeTypeList);
          let aaa = await getVideoTaskInfo({
            activityId: activity.activityData.activityId
          });
          activity.videoTaskInfo.length = 0;
          activity.videoTaskInfo.push(...aaa);
          let videoTaskProgress = await getVideoTaskProgress({
            activityId: activity.activityData.activityId
          });
          console.log(videoTaskProgress);
          if (videoTaskProgress == null) {
            return;
          }
          activity.videoTaskProgress = [];
          activity.videoTaskProgress.push(...videoTaskProgress);
        }
      }
    };
    const formatCurrentDate = date => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}.${month}.${day}`;
    };
    const getSignature = async directory => {
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    };
    const uploadStoreLocation = ref(null);
    const uploadStoreLocationAdd = ref(null);
    const uploadStoreLocationPopoverVisible = ref(false);
    const uploadStoreLocationAddPopoverVisible = ref(false);
    const uploadStoreLocationData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const uploadStoreLocationAddData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const openUploadStoreLocationPopover = () => {
      uploadStoreLocation.value.clearFiles();
      uploadStoreLocationPopoverVisible.value = true;
    };
    const openUploadStoreLocationAddPopover = () => {
      uploadStoreLocationAdd.value.clearFiles();
      uploadStoreLocationAddPopoverVisible.value = true;
    };
    const handleStoreLocationBeforeUpload = async file => {
      uploadStoreLocationData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadStoreLocationData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadStoreLocationData.signatureData.dir + fullName;
      uploadStoreLocationData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadStoreLocationData.signatureData.policy,
        OSSAccessKeyId: uploadStoreLocationData.signatureData.accessId,
        signature: uploadStoreLocationData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadStoreLocationData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleStoreLocationAddBeforeUpload = async file => {
      uploadStoreLocationAddData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadStoreLocationAddData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadStoreLocationAddData.signatureData.dir + fullName;
      uploadStoreLocationAddData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadStoreLocationAddData.signatureData.policy,
        OSSAccessKeyId: uploadStoreLocationAddData.signatureData.accessId,
        signature: uploadStoreLocationAddData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadStoreLocationAddData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleStoreLocationExceed = files => {
      uploadStoreLocation.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadStoreLocation.value.handleStart(file);
      uploadStoreLocation.value.submit();
    };
    const handleStoreLocationAddExceed = files => {
      uploadStoreLocationAdd.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadStoreLocationAdd.value.handleStart(file);
      uploadStoreLocationAdd.value.submit();
    };
    const handleStoreLocationOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadStoreLocationData.data.name,
            uploadedName: uploadStoreLocationData.data.key
          }
        };
        importStoreLocationRequest(activityUploadedRO);
      }
    };
    const handleStoreLocationAddOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadStoreLocationAddData.data.name,
            uploadedName: uploadStoreLocationAddData.data.key
          }
        };
        importStoreLocationAddRequest(activityUploadedRO);
      }
    };
    const importStoreLocationRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingActivityStoreList"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.importStoreLocation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202157") {
            uploadStoreLocationPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202170") {
            uploadStoreLocationPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const importStoreLocationAddRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingActivityStoreList"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.appendStoreLocation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202157") {
            uploadStoreLocationPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202170") {
            uploadStoreLocationPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const exportTaskModelClick = () => {
      getVideoTaskExcel(activityId);
    };
    const getVideoTaskExcel = activityId => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.getVideoTaskExcel(activityId).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const exportActivityStoreClick = () => {
      getStoreExport(activityId);
    };
    const getStoreExport = activityId => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.getStoreExport(activityId).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const exportActivityStoreLocationClick = () => {
      getStoreLocationExport(activityId);
    };
    const getStoreLocationExport = activityId => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.getStoreLocationExport(activityId).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const exportActivityInstallationClick = () => {
      getInstallationExport(activityId);
    };
    const getInstallationExport = activityId => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.getInstallationExport(activityId).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const uploadActivityInstallation = ref(null);
    const uploadActivityInstallationAdd = ref(null);
    const uploadActivityInstallationPopoverVisible = ref(false);
    const uploadActivityInstallationAddPopoverVisible = ref(false);
    const uploadActivityInstallationData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const uploadActivityInstallationAddData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const openUploadActivityInstallationPopover = () => {
      uploadActivityInstallation.value.clearFiles();
      uploadActivityInstallationPopoverVisible.value = true;
    };
    const openUploadActivityInstallationAddPopover = () => {
      uploadActivityInstallationAdd.value.clearFiles();
      uploadActivityInstallationAddPopoverVisible.value = true;
    };
    const handleActivityInstallationBeforeUpload = async file => {
      uploadActivityInstallationData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadActivityInstallationData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadActivityInstallationData.signatureData.dir + fullName;
      uploadActivityInstallationData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadActivityInstallationData.signatureData.policy,
        OSSAccessKeyId: uploadActivityInstallationData.signatureData.accessId,
        signature: uploadActivityInstallationData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadActivityInstallationData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleActivityInstallationAddBeforeUpload = async file => {
      uploadActivityInstallationAddData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadActivityInstallationAddData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadActivityInstallationAddData.signatureData.dir + fullName;
      uploadActivityInstallationAddData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadActivityInstallationAddData.signatureData.policy,
        OSSAccessKeyId: uploadActivityInstallationAddData.signatureData.accessId,
        signature: uploadActivityInstallationAddData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadActivityInstallationAddData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleActivityInstallationExceed = files => {
      uploadActivityInstallation.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadActivityInstallation.value.handleStart(file);
      uploadActivityInstallation.value.submit();
    };
    const handleActivityInstallationAddExceed = files => {
      uploadActivityInstallationAdd.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadActivityInstallationAdd.value.handleStart(file);
      uploadActivityInstallationAdd.value.submit();
    };
    const handleActivityInstallationOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadActivityInstallationData.data.name,
            uploadedName: uploadActivityInstallationData.data.key
          }
        };
        importActivityInstallationRequest(activityUploadedRO);
      }
    };
    const handleActivityInstallationAddOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadActivityInstallationAddData.data.name,
            uploadedName: uploadActivityInstallationAddData.data.key
          }
        };
        importActivityInstallationAddRequest(activityUploadedRO);
      }
    };
    const importActivityInstallationRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingSupplierStoreList"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.importActivityInstallation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202160") {
            uploadActivityInstallationPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202176") {
            uploadActivityInstallationPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const importActivityInstallationAddRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingSupplierStoreList"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.appendActivityInstallation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202160") {
            uploadActivityInstallationPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202176") {
            uploadActivityInstallationPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    //时间戳转时间
    const getDate = (data, notime) => {
      let date = new Date(data); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (notime) {
        return Y + M + D;
      } else {
        return Y + M + D + h + m + s;
      }
    };
    const activityEditClick = () => {
      route.push({
        path: "/activity-create/" + activityId
      });
    };
    const uploadInstallation = ref(null);
    const uploadInstallationAdd = ref(null);
    const uploadVideoTask = ref(null);
    const uploadInstallationPopoverVisible = ref(false);
    const uploadInstallationAddPopoverVisible = ref(false);
    const videoTaskPopoverVisible = ref(false);
    const uploadInstallationData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: [],
      syncDate: null
    });
    const uploadInstallationAddData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: [],
      syncDate: null
    });
    const uploadVideoTaskData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: [],
      syncDate: null
    });
    const openUploadInstallationPopover = () => {
      uploadInstallation.value.clearFiles();
      uploadInstallationPopoverVisible.value = true;
    };
    const openUploadInstallationAddPopover = () => {
      uploadInstallationAdd.value.clearFiles();
      uploadInstallationAddPopoverVisible.value = true;
    };
    const openVideoTaskPopover = () => {
      uploadVideoTask.value.clearFiles();
      videoTaskPopoverVisible.value = true;
    };
    const handleInstallationBeforeUpload = async file => {
      uploadInstallationData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadInstallationData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadInstallationData.signatureData.dir + fullName;
      uploadInstallationData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadInstallationData.signatureData.policy,
        OSSAccessKeyId: uploadInstallationData.signatureData.accessId,
        signature: uploadInstallationData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadInstallationData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleInstallationAddBeforeUpload = async file => {
      uploadInstallationAddData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadInstallationAddData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadInstallationAddData.signatureData.dir + fullName;
      uploadInstallationAddData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadInstallationAddData.signatureData.policy,
        OSSAccessKeyId: uploadInstallationAddData.signatureData.accessId,
        signature: uploadInstallationAddData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadInstallationAddData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleVideoTaskBeforeUpload = async file => {
      uploadVideoTaskData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadVideoTaskData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadVideoTaskData.signatureData.dir + fullName;
      uploadVideoTaskData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadVideoTaskData.signatureData.policy,
        OSSAccessKeyId: uploadVideoTaskData.signatureData.accessId,
        signature: uploadVideoTaskData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadVideoTaskData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleInstallationExceed = files => {
      uploadInstallation.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadInstallation.value.handleStart(file);
      uploadInstallation.value.submit();
    };
    const handleInstallationAddExceed = files => {
      uploadInstallationAdd.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadInstallationAdd.value.handleStart(file);
      uploadInstallationAdd.value.submit();
    };
    const handleInstallationExceedVideoTask = files => {
      uploadVideoTask.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadVideoTask.value.handleStart(file);
      uploadVideoTask.value.submit();
    };
    const handleInstallationOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadInstallationData.data.name,
            uploadedName: uploadInstallationData.data.key
          }
        };
        importInstallationRequest(activityUploadedRO);
      }
    };
    const handleInstallationAddOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadInstallationAddData.data.name,
            uploadedName: uploadInstallationAddData.data.key
          }
        };
        importInstallationAddRequest(activityUploadedRO);
      }
    };
    const handleVideoTaskOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadVideoTaskData.data.name,
            uploadedName: uploadVideoTaskData.data.key
          }
        };
        importVideoTaskExcel(activityUploadedRO);
      }
    };
    const importInstallationRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingBulkInstallAppointments"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.importInstallation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202163") {
            uploadInstallationPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202177") {
            uploadInstallationPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const importInstallationAddRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingBulkInstallAppointments"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.appendInstallation(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202163") {
            uploadInstallationPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202177") {
            uploadInstallationPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const importVideoTaskExcel = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.uploadingBulkInstallAppointments"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.activityRequest.importVideoTaskExcel(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          console.log(res);
          if (res.result.dataCode === "202510") {
            videoTaskPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202177") {
            videoTaskPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const uploadFile = ref(null);
    const uploadFilePopoverVisible = ref(false);
    const uploadFileData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const openUploadFilePopover = () => {
      uploadFile.value.clearFiles();
      uploadFilePopoverVisible.value = true;
    };
    const handleFileBeforeUpload = async file => {
      uploadFileData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadFileData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadFileData.signatureData.dir + fullName;
      uploadFileData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadFileData.signatureData.policy,
        OSSAccessKeyId: uploadFileData.signatureData.accessId,
        signature: uploadFileData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadFileData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleFileExceed = files => {
      uploadFile.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadFile.value.handleStart(file);
      uploadFile.value.submit();
    };
    const handleFileOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadFileData.data.name,
            uploadedName: uploadFileData.data.key
          }
        };
        uploadFileRequest(activityUploadedRO);
      }
    };
    const uploadFileRequest = async activityUploadedRO => {
      proxy.$api.activityRequest.activityUploadFile(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202165") {
            let uploaded = res.result.data;
            uploaded.date = formatCurrentDate(new Date(uploaded.uploadedTime));
            debugger;
            activity.activityData.uploaded.push(uploaded);
            uploadFilePopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const deleteUploadedFileRequest = async (activityDeleteUploadedRO, uploaded) => {
      proxy.$api.activityRequest.deleteUploadFile(activityDeleteUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202167") {
            activity.activityData.uploaded = activity.activityData.uploaded.filter(obj => obj !== uploaded);
            uploadFilePopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const siteCodeClick = row => {
      getInstallationWxCode(row.vendorId);
      // QRcodeVisible.value = true;
      // console.log(row);
      // QRcodeMsg.vendorName = row.vendorName;
      // jumpUrl.value = currentUrl + "/install-info/";
      // jumpUrl.value =
      //   jumpUrl.value + activity.activityData.activityId + "/" + row.vendorId;
      // console.log(jumpUrl.value);
    };

    const progressColor = ["#FF3C66", "#20D5B1", "#FFB742", "#429BFF", "#429BFF"];
    const progressText = computed(() => [t("activityDetail.shippingProgress"), t("activityDetail.deliveryProgress"), t("activityDetail.installationProgress"), t("activityDetail.acceptanceProgress"), t("activityDetail.reviewProgress")]);
    const storeDetailClick = () => {
      route.push({
        path: "/store-manage/" + activityId
      });
    };
    const storeTypeClick = storeTypeId => {
      route.push({
        path: "/store-manage/" + activityId + "/" + storeTypeId
      });
    };
    const installClick = stat => {
      console.log(stat);
      let convey = stat[1];
      let install = stat[3];
      cookies.set("installConvey_" + activityId, JSON.stringify({
        convey: convey,
        install: install
      }), {
        expires: 30
      });
      window.localStorage.removeItem("installation_page_param");
      route.push({
        path: "/install-convey/" + activityId
      });
    };
    const installVendorClick = (vendorId, stat) => {
      let convey = stat[1];
      let install = stat[3];
      cookies.set("installConvey_" + activityId, JSON.stringify({
        convey: convey,
        install: install
      }), {
        expires: 30
      });
      window.localStorage.removeItem("installation_page_param");
      route.push({
        path: "/install-convey/" + activityId + "/" + vendorId
      });
    };

    //二维码复制
    const copyQrcode = () => {
      html2canvas(QRcodeBox.value, {
        useCORS: true,
        // 【重要】开启跨域配置
        allowTaint: true // 允许跨域图片
      }).then(canvas => {
        canvas.toBlob(blob => {
          const data = [new ClipboardItem({
            [blob.type]: blob
          })];
          navigator.clipboard.write(data).then(() => {
            console.log(t("activityDetail.success"));
            ElNotification({
              title: t("activityDetail.success"),
              message: t("activityDetail.copiedToClipboard"),
              type: "success",
              duration: 3000
            });
          }, () => {
            console.log(t("activityDetail.fail"));
            ElNotification({
              title: t("activityDetail.fail"),
              message: t("activityDetail.copyFail"),
              type: "error",
              duration: 3000
            });
          });
        }, "image/png");
      });
    };
    const exportLogisticsExportClick = () => {
      getLogisticsExport(activityId);
    };
    const getLogisticsExport = activityId => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: t("activityDetail.exportingTemplate"),
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.scheduleRequest.getLogisticsExport(activityId).then(res => {
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const uploadConverPane = ref(null);
    const uploadConverData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: []
    });
    const uploadConverPopoverVisible = ref(false);
    const openUploadConverPopover = () => {
      uploadConverPane.value[0].clearFiles();
      uploadConverPopoverVisible.value = true;
    };
    const handleConverExceed = files => {
      uploadConverPane.value[0].clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadConverPane.value[0].handleStart(file);
      uploadConverPane.value[0].submit();
    };
    const handleConverBeforeUpload = async file => {
      uploadConverData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadConverData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadConverData.signatureData.dir + fullName;
      uploadConverData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadConverData.signatureData.policy,
        OSSAccessKeyId: uploadConverData.signatureData.accessId,
        signature: uploadConverData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadConverData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const handleConverOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        const activityUploadedRO = {
          activityId: activityId,
          uploadedRO: {
            fileName: uploadConverData.data.name,
            uploadedName: uploadConverData.data.key
          }
        };
        importConverRequest(activityUploadedRO);
      }
    };
    const importConverRequest = async activityUploadedRO => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: "正在pdf报表并下载",
        background: "rgba(0, 0, 0, 0.7)"
      });
      proxy.$api.scheduleRequest.importLogistics(activityUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202261") {
            uploadConverPopoverVisible.value = false;
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202266") {
            uploadConverPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
        nextTick(() => {
          loadingInstance.close();
        });
      });
    };
    const dsyncInstallationDateClick = () => {
      dsyncInstallationDateRequest(activityId);
    };
    const dsyncInstallationDateRequest = async activityId => {
      proxy.$api.activityRequest.syncInstallationDate(activityId).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202183") {
            ElNotification({
              title: t("activityDetail.success"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            loadActivityData();
          } else if (res.result.dataCode === "202182") {
            uploadConverPopoverVisible.value = false;
            activity.activityImportMessageVisible = true;
            activity.activityImportMessages = res.result.data;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const downloadFile = (url, fileName) => {
      fetch(url).then(response => response.blob()).then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      });
    };
    const getInstallationWxCode = vendorId => {
      let installationWxCodeRO = {
        activityId: activityId,
        vendorId: vendorId
      };
      proxy.$api.wxRequest.getInstallationWxCode(installationWxCodeRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "200000") {
            wxCodeImage.value = res.result.data;
            QRcodeVisible.value = true;
          } else {
            ElNotification({
              title: t("activityDetail.fail"),
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: t("activityDetail.fail"),
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: t("activityDetail.error"),
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const chooseVendorProgress = (type, index) => {
      progressType.value = type;
      progressIndex.value = index;
    };
    const goInstallCover = () => {
      if (progressType.value === "all") {
        installClick(activity.activityStat.totalProgress);
      } else {
        installVendorClick(activity.activityStat.activityVendorStats[progressIndex.value].vendorId, activity.activityStat.activityVendorStats[progressIndex.value].progress);
      }
    };
    const videoDialogVisible = ref(false);

    // 发布任务按钮
    const publishTask = () => {
      videoDialogVisible.value = true;
      activity.videoData.activityName = activity.activityData.activityName;
      activity.videoData.activityTime = activity.activityData.activityBegin + '-' + activity.activityData.activityEnd;
    };
    // 编辑任务按钮
    const editTask = () => {
      let taskInfo = activity.videoTaskInfo[0];
      console.log(taskInfo);
      activity.videoData.note = taskInfo.videoTaskDesc;
      activity.videoData.videoUrl = taskInfo.videoAddress;
      activity.videoData.videoTaskId = taskInfo.videoTaskId;
      activity.videoData.activityName = activity.activityData.activityName;
      activity.videoData.activityTime = activity.activityData.activityBegin + '-' + activity.activityData.activityEnd;
      videoDialogVisible.value = true;
    };
    const addTask = () => {
      activity.videoData.videoUrl.push('');
    };
    const deleteTask = index => {
      activity.videoData.videoUrl.splice(index, 1);
    };

    //多选下拉框------------------------
    //获取视频任务详情
    const getVideoTaskInfo = async id => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getVideoTaskInfo(id, true).then(res => {
          if (res.result.data.length > 0) {
            res.result.data[0].videoAddress = JSON.parse(res.result.data[0].videoAddress);
          }
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //获取视频任务进度详情
    const getVideoTaskProgress = async id => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getVideoTaskProgress(id, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //测试接口2
    const getStoreLocationInfo = async id => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocationInfo(id, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //测试接口4
    const getVendorStoreLocationCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getVendorStoreLocationCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //测试接口5
    const getScreenDailyCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getScreenDailyCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //测试接口6
    const getScreeTodayCount = async resRo => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getScreeTodayCount(resRo).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //获取店铺类型
    const getStoreType = async Ro => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityStoreType(Ro, true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //获取店铺
    const getStoreByPageRequest = async (index, pageSize, storePageRO) => {
      spinLoading.value = true;
      //传空数组后台报错，在这里判断下改成null
      let copyData = JSON.parse(JSON.stringify(storePageRO));
      if (copyData.storeTypeIds.length === 0) {
        copyData.storeTypeIds = null;
      }
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityStores(copyData).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202192") {
              if (res.result.data == null) {
                res.result.data = [];
              }
              resolve(res.result.data);
              spinLoading.value = false;
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            spinLoading.value = false;
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          spinLoading.value = false;
          if (error.code != "TOKEN_MISSING") {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //根据店铺查询点位
    const getXinfaStoreLocation = async resRo => {
      spinLoading.value = true;
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getXinfaStoreLocation(resRo, true).then(res => {
          resolve(res.result.data);
          spinLoading.value = false;
        }).catch(error => {
          reject(error);
          spinLoading.value = false;
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //根据店铺查询位置
    const selectScreenDict = async resRo => {
      spinLoading.value = true;
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.selectScreenDict(resRo, true).then(res => {
          resolve(res.result.data);
          spinLoading.value = false;
        }).catch(error => {
          reject(error);
          spinLoading.value = false;
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //发布任务
    const addVideoTask = async resRo => {
      spinLoading.value = true;
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.addVideoTask(resRo, true).then(res => {
          if (res.result.dataCode === "202508") {
            spinLoading.value = false;
            resolve(res.result.data);
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
          if (res.result.dataCode === "202507") {
            spinLoading.value = false;
            resolve(res.result.data);
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            clearVideoFromData();
          }
        }).catch(error => {
          reject(error);
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //发布任务
    const updateVideoTask = async resRo => {
      spinLoading.value = true;
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.updateVideoTask(resRo, true).then(res => {
          if (res.result.dataCode === "202508") {
            spinLoading.value = false;
            resolve(res.result.data);
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
          if (res.result.dataCode === "202507") {
            spinLoading.value = false;
            resolve(res.result.data);
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            clearVideoFromData();
          }
        }).catch(error => {
          reject(error);
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //更新店铺类型全选状态
    const updateCheckAllStatus = index => {
      const totalOptions = storeData.storeTypeData.length;
      const selectedLength = activity.videoData.taskList[index].taskStoreType.length;
      storeData.storeTypeCheckAll = selectedLength === totalOptions;
      // storeData.storePageRO.indeterminate =  selectedLength > 0 && selectedLength < totalOptions;
    };
    // 店铺类型全选
    const storeTypeCheckAllChange = async (e, index) => {
      const checked = e.target.checked;
      activity.videoData.taskList[index].taskStoreType = checked ? storeData.storeTypeData.map(item => item.storeTypeId) : [];
      updateCheckAllStatus(index);
      let data = {
        storeTypeIds: activity.videoData.taskList[index].taskStoreType,
        activityId: activity.activityData.activityId
      };
      if (data.storeTypeIds.length > 0) {
        let res = await getStoreByPageRequest(1, 10000, data);
        storeData.storeNameData.length = 0;
        storeData.storeNameData.push(...res);
      }
      activity.videoData.taskList[index].taskStoreName = [];
    };
    // 店铺类型单选
    const onStoreTypeCheckboxChange = async (storeTypeId, e, index) => {
      const checked = e.target.checked;
      const selected = activity.videoData.taskList[index].taskStoreType.slice();
      if (checked) {
        selected.push(storeTypeId);
      } else {
        const index1 = selected.indexOf(storeTypeId);
        if (index1 > -1) {
          selected.splice(index1, 1);
        }
      }
      activity.videoData.taskList[index].taskStoreType = selected;
      updateCheckAllStatus(index);
      let data = {
        storeTypeIds: activity.videoData.taskList[index].taskStoreType,
        activityId: activity.activityData.activityId
      };
      if (data.storeTypeIds.length > 0) {
        let res = await getStoreByPageRequest(1, 10000, data);
        storeData.storeNameData.length = 0;
        storeData.storeNameData.push(...res);
      }
      activity.videoData.taskList[index].taskStoreName = [];
    };
    //更新店铺名称全选状态
    const updateStoreNameCheckAllStatus = index => {
      const totalOptions = storeData.storeNameData.length;
      const selectedLength = activity.videoData.taskList[index].taskStoreName.length;
      storeData.storeNameCheckAll = selectedLength === totalOptions;
      // storeData.storePageRO.indeterminate =  selectedLength > 0 && selectedLength < totalOptions;
    };
    // 店铺名称全选
    const storeNameCheckAllChange = async (e, index) => {
      const checked = e.target.checked;
      activity.videoData.taskList[index].taskStoreName = checked ? storeData.storeNameData.map(item => item.storeCode) : [];
      updateStoreNameCheckAllStatus(index);
      let resRo = {
        storeTypes: activity.videoData.taskList[index].taskStoreType,
        storeCodes: activity.videoData.taskList[index].taskStoreName,
        groupType: 'supportType'
      };
      if (resRo.storeCodes.length > 0) {
        let xinFaStoreLocation = await selectScreenDict(resRo);
        storeData.supportTypeData.length = 0;
        for (let x = 0; x < xinFaStoreLocation.length; x++) {
          let obj = {
            value: xinFaStoreLocation[x],
            label: xinFaStoreLocation[x],
            isLeaf: false
          };
          storeData.supportTypeData.push(obj);
        }
        let title = {
          value: 'title-province',
          // 不可选的标题
          label: '支持类型',
          disabled: true
        };
        storeData.supportTypeData.unshift(title);
      }
      activity.videoData.taskList[index].supportType = [];
    };
    // 店铺名称单选
    const onStoreNameCheckboxChange = async (storeCode, e, index) => {
      const checked = e.target.checked;
      const selected = activity.videoData.taskList[index].taskStoreName.slice();
      if (checked) {
        selected.push(storeCode);
      } else {
        const index1 = selected.indexOf(storeCode);
        if (index1 > -1) {
          selected.splice(index1, 1);
        }
      }
      activity.videoData.taskList[index].taskStoreName = selected;
      updateStoreNameCheckAllStatus(index);
      let resRo = {
        storeTypes: activity.videoData.taskList[index].taskStoreType,
        storeCodes: activity.videoData.taskList[index].taskStoreName,
        groupType: 'supportType'
      };
      if (resRo.storeCodes.length > 0) {
        let xinFaStoreLocation = await selectScreenDict(resRo);
        storeData.supportTypeData.length = 0;
        for (let x = 0; x < xinFaStoreLocation.length; x++) {
          let obj = {
            value: xinFaStoreLocation[x],
            label: xinFaStoreLocation[x],
            isLeaf: false
          };
          storeData.supportTypeData.push(obj);
        }
        let title = {
          value: 'title-province',
          // 不可选的标题
          label: '支持类型',
          disabled: true
        };
        storeData.supportTypeData.unshift(title);
      }
      activity.videoData.taskList[index].supportType = [];
    };
    //重置发布视频的表单并关闭弹框
    const clearVideoFromData = async () => {
      activity.videoData = {
        activityName: '',
        activityTime: '',
        taskList: [{
          taskTime: null,
          taskStoreType: [],
          taskStoreName: [],
          supportType: []
        }],
        videoUrl: '',
        note: ''
      };
      activity.deleteSubTaskId = [];
      videoDialogVisible.value = false;
    };
    //展开下拉菜单的回调
    const dropdownVisibleChange = async (e, index) => {
      dropdownVisible.value = e;
      if (e) {
        console.log(index);
        if (activity.videoTaskInfo.length > 0) {
          let data = {
            storeTypeIds: activity.videoData.taskList[index].taskStoreType,
            activityId: activity.activityData.activityId
          };
          let res = await getStoreByPageRequest(1, 10000, data);
          storeData.storeNameData.length = 0;
          storeData.storeNameData.push(...res);
          updateStoreNameCheckAllStatus(index);
        }
      }
    };
    //展开下拉菜单的回调
    const dropdownVisibleChangeLocation = async (e, index) => {
      if (e) {
        console.log(index);
        if (activity.videoTaskInfo.length > 0) {
          let resRo = {
            storeTypes: activity.videoData.taskList[index].taskStoreType,
            storeCodes: activity.videoData.taskList[index].taskStoreName,
            groupType: 'supportType'
          };
          let xinFaStoreLocation = await selectScreenDict(resRo);
          storeData.supportTypeData.length = 0;
          for (let x = 0; x < xinFaStoreLocation.length; x++) {
            let obj = {
              value: xinFaStoreLocation[x],
              label: xinFaStoreLocation[x],
              isLeaf: false
            };
            storeData.supportTypeData.push(obj);
          }
          let title = {
            value: 'title-province',
            // 不可选的标题
            label: '支持类型',
            disabled: true
          };
          storeData.supportTypeData.unshift(title);
        }
      }
    };
    const openChange = async (e, index) => {
      console.log(e, index);
      if (e) {
        let supportTypes = activity.videoData.taskList[index].supportType;
        let resRo = {
          supportType: supportTypes[0],
          aec: supportTypes[1],
          gender: supportTypes[2],
          category: supportTypes[3],
          region: supportTypes[4],
          location: supportTypes[5],
          storeTypes: activity.videoData.taskList[index].taskStoreType,
          storeCodes: activity.videoData.taskList[index].taskStoreName
        };
        let xinFaStoreLocation = await getXinfaStoreLocation(resRo);
        storeData.showLocationData.length = 0;
        storeData.showLocationData.push(...xinFaStoreLocation);
      }
    };
    const storeData = reactive({
      storeTypeData: [],
      storeTypeCheckAll: false,
      storeNameData: [],
      storeNameCheckAll: false,
      supportTypeData: [],
      showLocationData: []
    });
    const pubTaskCancel = () => {
      clearVideoFromData();
    };
    //确认增加
    const pubTaskOk = async () => {
      let resRo2 = {
        activityId: activity.activityData.activityId,
        videoTaskName: activity.activityData.activityName,
        videoAddress: JSON.stringify(activity.videoData.videoUrl),
        videoTaskDesc: activity.videoData.note
      };
      console.log(resRo2);
      let addVideoTaskRes = await addVideoTask(resRo2);
      console.log(addVideoTaskRes);
      loadActivityData();
    };
    //确认修改
    const editTaskOk = async () => {
      let resRo2 = {
        activityId: activity.activityData.activityId,
        videoTaskName: activity.activityData.activityName,
        videoAddress: JSON.stringify(activity.videoData.videoUrl),
        videoTaskDesc: activity.videoData.note,
        videoTaskId: activity.videoData.videoTaskId
      };
      console.log(resRo2);
      let addVideoTaskRes = await updateVideoTask(resRo2);
      console.log(addVideoTaskRes);
      let aaa = await getVideoTaskInfo({
        activityId: activity.activityData.activityId
      });
      activity.videoTaskInfo = [];
      activity.videoTaskInfo.push(...aaa);
      loadActivityData();
    };
    const loadDataTask = async (index, selectedOptions) => {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let label = targetOption.label;
      // 这里去请求数据，和前面例子一样
      if (selectedOptions.length === 1) {
        let resRo = {
          storeTypes: activity.videoData.taskList[index].taskStoreType,
          storeCodes: activity.videoData.taskList[index].taskStoreName,
          supportType: label,
          groupType: 'aec'
        };
        let xinFaStoreLocation = await selectScreenDict(resRo);
        targetOption.children = xinFaStoreLocation.map(item => ({
          value: item,
          label: item,
          isLeaf: false
        }));
        targetOption.children.unshift({
          value: 'title-province',
          label: 'AEC',
          disabled: true
        });
        storeData.supportTypeData = [...storeData.supportTypeData];
      }
      if (selectedOptions.length === 2) {
        let resRo = {
          storeTypes: activity.videoData.taskList[index].taskStoreType,
          storeCodes: activity.videoData.taskList[index].taskStoreName,
          supportType: selectedOptions[0].label,
          aec: label,
          groupType: 'gender'
        };
        let xinFaStoreLocation = await selectScreenDict(resRo);
        targetOption.children = xinFaStoreLocation.map(item => ({
          value: item,
          label: item,
          isLeaf: false
        }));
        targetOption.children.unshift({
          value: 'title-province',
          label: '性别',
          disabled: true
        });
        storeData.supportTypeData = [...storeData.supportTypeData];
      }
      if (selectedOptions.length === 3) {
        let resRo = {
          storeTypes: activity.videoData.taskList[index].taskStoreType,
          storeCodes: activity.videoData.taskList[index].taskStoreName,
          supportType: selectedOptions[0].label,
          aec: selectedOptions[1].label,
          gender: label,
          groupType: 'category'
        };
        let xinFaStoreLocation = await selectScreenDict(resRo);
        targetOption.children = xinFaStoreLocation.map(item => ({
          value: item,
          label: item,
          isLeaf: false
        }));
        targetOption.children.unshift({
          value: 'title-province',
          label: 'category',
          disabled: true
        });
        storeData.supportTypeData = [...storeData.supportTypeData];
      }
      if (selectedOptions.length === 4) {
        let resRo = {
          storeTypes: activity.videoData.taskList[index].taskStoreType,
          storeCodes: activity.videoData.taskList[index].taskStoreName,
          supportType: selectedOptions[0].label,
          aec: selectedOptions[1].label,
          gender: selectedOptions[2].label,
          category: label,
          groupType: 'region'
        };
        let xinFaStoreLocation = await selectScreenDict(resRo);
        targetOption.children = xinFaStoreLocation.map(item => ({
          value: item,
          label: item,
          isLeaf: false
        }));
        targetOption.children.unshift({
          value: 'title-province',
          label: 'region',
          disabled: true
        });
        storeData.supportTypeData = [...storeData.supportTypeData];
      }
      if (selectedOptions.length === 5) {
        let resRo = {
          storeTypes: activity.videoData.taskList[index].taskStoreType,
          storeCodes: activity.videoData.taskList[index].taskStoreName,
          supportType: selectedOptions[0].label,
          aec: selectedOptions[1].label,
          gender: selectedOptions[2].label,
          category: selectedOptions[3].label,
          region: label,
          groupType: 'location'
        };
        let xinFaStoreLocation = await selectScreenDict(resRo);
        targetOption.children = xinFaStoreLocation.map(item => ({
          value: item,
          label: item,
          isLeaf: true
        }));
        targetOption.children.unshift({
          value: 'title-province',
          label: 'location',
          disabled: true
        });
        storeData.supportTypeData = [...storeData.supportTypeData];
      }
      if (selectedOptions.length === 6) {
        console.log(selectedOptions);
      }
    };
    const openLink = url => {
      window.open(url, "_blank");
    };
    return {
      openLink,
      openChange,
      // cascaderChange,
      dropdownVisibleChangeLocation,
      dropdownVisibleChange,
      editTask,
      editTaskOk,
      clearVideoFromData,
      loadDataTask,
      storeNameCheckAllChange,
      onStoreNameCheckboxChange,
      pubTaskCancel,
      pubTaskOk,
      onStoreTypeCheckboxChange,
      storeTypeCheckAllChange,
      storeData,
      addTask,
      deleteTask,
      publishTask,
      videoDialogVisible,
      tokenData,
      permission,
      activity,
      removeFile,
      openUploadStoreLocationPopover,
      openUploadStoreLocationAddPopover,
      uploadStoreLocation,
      uploadStoreLocationAdd,
      uploadStoreLocationPopoverVisible,
      uploadStoreLocationAddPopoverVisible,
      uploadStoreLocationData,
      uploadStoreLocationAddData,
      handleStoreLocationExceed,
      handleStoreLocationAddExceed,
      handleStoreLocationBeforeUpload,
      handleStoreLocationAddBeforeUpload,
      handleStoreLocationOnSuccess,
      handleStoreLocationAddOnSuccess,
      exportActivityStoreClick,
      exportActivityStoreLocationClick,
      openUploadActivityInstallationPopover,
      openUploadActivityInstallationAddPopover,
      uploadActivityInstallation,
      uploadActivityInstallationAdd,
      uploadActivityInstallationPopoverVisible,
      uploadActivityInstallationAddPopoverVisible,
      uploadActivityInstallationData,
      uploadActivityInstallationAddData,
      handleActivityInstallationExceed,
      handleActivityInstallationAddExceed,
      handleActivityInstallationBeforeUpload,
      handleActivityInstallationAddBeforeUpload,
      handleActivityInstallationOnSuccess,
      handleActivityInstallationAddOnSuccess,
      activityEditClick,
      exportActivityInstallationClick,
      openUploadInstallationPopover,
      openUploadInstallationAddPopover,
      uploadInstallation,
      uploadInstallationAdd,
      uploadVideoTask,
      uploadInstallationPopoverVisible,
      uploadInstallationAddPopoverVisible,
      openVideoTaskPopover,
      videoTaskPopoverVisible,
      uploadInstallationData,
      uploadInstallationAddData,
      uploadVideoTaskData,
      handleInstallationExceed,
      handleInstallationAddExceed,
      handleInstallationExceedVideoTask,
      handleInstallationBeforeUpload,
      handleInstallationAddBeforeUpload,
      handleInstallationOnSuccess,
      handleInstallationAddOnSuccess,
      handleVideoTaskOnSuccess,
      openUploadFilePopover,
      uploadFile,
      uploadFilePopoverVisible,
      uploadFileData,
      handleFileExceed,
      handleFileBeforeUpload,
      handleFileOnSuccess,
      siteCodeClick,
      progressColor,
      progressText,
      storeDetailClick,
      storeTypeClick,
      installClick,
      installVendorClick,
      QRcodeVisible,
      QRcodeMsg,
      jumpUrl,
      copyQrcode,
      getDate,
      QRcodeBox,
      exportLogisticsExportClick,
      uploadConverPane,
      uploadConverPopoverVisible,
      uploadConverData,
      openUploadConverPopover,
      handleConverExceed,
      handleConverBeforeUpload,
      handleConverOnSuccess,
      dsyncInstallationDateClick,
      downloadFile,
      wxCodeImage,
      getInstallationWxCode,
      progressType,
      progressIndex,
      chooseVendorProgress,
      goInstallCover,
      stepsCurrent,
      spinLoading,
      exportTaskModelClick,
      handleVideoTaskBeforeUpload,
      getStoreNameSet,
      dropdownVisible
    };
  }
});